import Vue from 'vue'
import VueScrollReveal from 'vue-scroll-reveal'

Vue.use(VueScrollReveal, {
  class: 'revealed',
  delay: 250,
  duration: 800,
  scale: 0.95,
  distance: '1rem',
  mobile: false,
  viewOffset: {
    bottom: 100
  }
})